import Computer, { AgentType } from 'mbs-ui-shared@models/Computer';

export enum RMMSidePanelTab {
  general = 'general',
  pcInfo = 'pc-info',
  processes = 'processes',
  processesCharts = 'processesCharts',
  processesGrid = 'processesGrid',
  services = 'services',
  software = 'software',
  patch = 'patch',
  availableHotfixes = 'availableHotfixes',
  installedHotfixes = 'installedHotfixes',
  hardware = 'hardware',
  disk = 'disk',
  printers = 'printers',
  antivirus = 'antivirus',
  event = 'event',
  hyperv = 'hyperv',
  powershell = 'powershell',
  remoteRegistry = 'remote-registry',
  command = 'command'
}

export const enabledRMMSidePanelTabs = (computer: Computer): RMMSidePanelTab[] => {
  const isOnlineAgent = Computer.isAgentOnline(computer, AgentType.RMM);
  const notUnix = !Computer.isUnix(computer);

  return [
    RMMSidePanelTab.general,
    RMMSidePanelTab.pcInfo,
    RMMSidePanelTab.processes,
    RMMSidePanelTab.processesGrid,
    RMMSidePanelTab.services,
    RMMSidePanelTab.software,
    RMMSidePanelTab.patch,
    RMMSidePanelTab.availableHotfixes,
    RMMSidePanelTab.installedHotfixes,
    RMMSidePanelTab.disk,
    RMMSidePanelTab.printers,
    RMMSidePanelTab.event
  ]
    .concat(isOnlineAgent ? [RMMSidePanelTab.processesCharts, RMMSidePanelTab.powershell] : [])
    .concat(notUnix ? [RMMSidePanelTab.hardware, RMMSidePanelTab.antivirus, RMMSidePanelTab.hyperv] : [])
    .concat(isOnlineAgent && notUnix ? [RMMSidePanelTab.remoteRegistry] : []);
};
